<template>
	<div class="lesson-detail-wrapper">
		<div class="info">
			<div class="info-pic f-img-box">
				<img :src="data.cover_img">
			</div>
			<div class="info-title">{{data.course_title}}</div>
			<div class="info-line f-cb">
				<div class="info-num"><span>{{data.baoming_num}}</span>人在学 <!--?人学过--></div>
				<div class="info-score">
					<div class="info-stars f-cb">
						<star :num="countStar(data.score)"></star>
					</div>
					{{data.score?data.score+"分":"暂无评价"}}
				</div>
			</div>
      <div class="info-line f-cb" style="position: relative;">
        <div class="info-time" style="margin-left:0.4rem;font-size: 0.346rem;color:#9EA7B4;">发布时间：<span>{{data.format_create_time}}</span></div>
        <div class="info-surveybtn" v-if="data.questionary_link" @click="go_questionnaire()">课程检测</div>
      </div>
		</div>
		<div class="lesson-intro">
			<div class="lesson-detail-title"><img src="./title-left.png"><span>课程介绍</span><img src="./title-right.png"></div>
			<div class="lesson-intro-text">
				<div class="lesson-intro-text-inner" v-html="data.content" v-if="data.content"></div>
				<div v-else>无内容</div>
			</div>
			<div class="lesson-intro-more" v-if="needMore" @click="showMore"><div></div></div>
		</div>
		<div class="teacher-intro">
			<div class="lesson-detail-title"><img src="./title-left.png"><span>老师介绍</span><img src="./title-right.png"></div>
			<ul class="teacher-intro-items">
				<!--<li class="teacher-intro-item">
					<div class="teacher-intro-title f-cb">
						<div class="teacher-intro-avatar">
							<img src="./star-light.png">
						</div>
						<div class="teacher-intro-name">冯保善</div>
					</div>
					<div class="teacher-intro-text o3">老师介绍老师介绍老师介绍老师介绍老师介绍老师介绍</div>
				</li>-->
				<li class="teacher-intro-item" v-for="item in teachers" @click="toTeacher(item.id)">
					<div class="teacher-intro-title f-cb">
						<div class="teacher-intro-avatar f-img-box">
							<img :src="item.avatar?item.avatar:teacherAvatar">
						</div>
						<div class="teacher-intro-name">{{item.nick_name}}</div>
					</div>
					<!--<div class="teacher-intro-text o3" >{{item.profile}}</div>-->
					<div class="teacher-intro-text o3" v-html="item.profile"></div>
				</li>
			</ul>
		</div>
		<div class="catalog">
			<div class="lesson-detail-title"><img src="./title-left.png"><span>课程目录</span><img src="./title-right.png"></div>
			<ul class="catalog-chapters">
				<!--<li class="catalog-chapter">
					<div class="catalog-chapter-title">第01章·文学阅读的发展</div>
					<ul class="catalog-items">
						<li class="catalog-item">
							<div class="catalog-item-title">第01节·文学阅读在国际上的兴起</div>
							<div class="catalog-item-time"><img src="./play.png">25:33</div>
						</li>
						<li class="catalog-item">
							<div class="catalog-item-title">第01节·文学阅读在中国的发展</div>
							<div class="catalog-item-time"><img src="./play.png">25:33</div>
						</li>
					</ul>
				</li>-->
				<li class="catalog-chapter" v-for="(item,index) in lessons">
					<div class="catalog-chapter-title o1">第 {{index+1}} 章 · {{item.title}}</div>
					<ul class="catalog-items">
						<!--<li class="catalog-item">
							<div class="catalog-item-title">第01节·人文的概述</div>
							<div class="catalog-item-time"><img src="./play.png">25:33</div>
						</li>-->
						<li class="catalog-item" v-for="(value,num) in item.children" @click="toLesson(value.id)">
							<div class="catalog-item-title o1">第 {{num+1}} 节 · {{value.title}}</div>
							<div class="catalog-item-time"><img src="./play.png">{{countTime(value.video_time)}}</div>
						</li>
					</ul>
				</li>
			</ul>
		</div>
		<div class="bottom-bar">
			<div class="bottom-bar-share" @click="isOpsMaskShow=true"></div>
			<div class="bottom-bar-fav" @click="addFav" :class="{'bottom-bar-fav-active':isFav}"></div>

<!--			<div class="bottom-bar-enroll" v-if="enrollStatus===1 || enrollStatus===0 || enrollStatus===2" @click="begin_study">开始学习</div>-->
			<div class="bottom-bar-enroll" v-if="enrollStatus===1 || enrollStatus===0 || enrollStatus===2" @click="go_study">开始学习</div>
			<div class="bottom-bar-enroll" v-if="enrollStatus===11" @click="begin_study">报名</div>
			<!--<div class="bottom-bar-enroll" v-else-if="enrollStatus===2" @click="$router.push('/lesson-desc/'+$route.params.id+'/'+sectionId)">继续学习</div>-->
			<!--<div class="bottom-bar-enroll bottom-bar-enroll-enroll" v-else-if="enrollStatus===0" @click="enroll">报名学习</div>-->
			<div class="bottom-bar-enroll bottom-bar-enroll-disabled" v-else-if="enrollStatus===3">暂未开放</div>
			<div class="bottom-bar-enroll bottom-bar-enroll-disabled" v-else-if="enrollStatus===4">已过期</div>
			<div class="bottom-bar-enroll bottom-bar-enroll-disabled" v-else-if="enrollStatus===5">无课程</div>

		</div>
		<dialog-mask :open="isOpsMaskShow" @click.native="isOpsMaskShow=false">
			<div class="share-dialog-inner">
        <div class="share-dialog-text">
          <div>点击右上角</div>
          <div>分享给你的朋友吧</div>
        </div>
			</div>
		</dialog-mask>
    <login-dialog :isOpen="isLoginDialogShow" @close="isLoginDialogShow=false"></login-dialog>
	</div>
</template>

<script>
    //获取导航参数
	function geturl_j2(name){
	   return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
	}
  //   var v_key = geturl_j2('v_key');
	// var login_status = geturl_j2('login_status');
	import star from "../star/star.vue"
	import mask from "../mask/mask.vue";
	export default{
		data(){
			return{
        v_key:geturl_j2('v_key'),
        login_status:geturl_j2('login_status'),
				data:{},
				teachers:[],
				lessons:[],
				needMore:false,
				isFav:false,
				// enrollStatus:-1,//0未报名 1开始学习 2继续学习 3暂未开放 4已过期
				enrollStatus:-1,//0未报名 1开始学习 2继续学习 3暂未开放 4已过期 11报名学习
				sectionId:null,
				isOpsMaskShow:false,
        isLoginDialogShow:false
			}
		},
		methods:{
		  begin_study(){
			if(this.login_status==1){
        		if (!this.$store.state.isLogin) {
          			this.isLoginDialogShow = true;
          			return;
        		}
      		}
        if(this.$store.state.isLogin){//1  //登录后报名学习
          this.$api.get("",{
            api:"/v1/baoming/create",
            user_type:this.tools.getStorage("user_type"),
            course_id:this.$route.params.id
          },res=>{
            if(res.status==1){
                // this.$router.push('/lesson-desc/'+this.$route.params.id+'/'+this.sectionId)
              this.enrollStatus=1;

            }else{
              this.$toast(res.msg);
            }
          })
        }else{ //未登录开始学习
          // this.$router.push('/lesson-desc/'+this.$route.params.id+'/'+this.sectionId)
        }
		  },
      go_study(){
        this.$router.push('/lesson-desc/'+this.$route.params.id+'/'+this.sectionId)
      },
			numConversion(num){
				switch(num){
					case 1:return "一";break;
					case 2:return "二";break;
					case 3:return "三";break;
					case 4:return "四";break;
					case 5:return "五";break;
					case 6:return "六";break;
					case 7:return "七";break;
					case 8:return "八";break;
					case 9:return "九";break;
				}
			},
			checkMore(){//检查是否需要更多按钮
				if(document.querySelector(".lesson-intro-text-inner").offsetHeight>document.querySelector(".lesson-intro-text").offsetHeight){
					this.needMore=true;
				}
			},
			showMore(e){
				document.querySelector(".lesson-intro-text").style["max-height"]="none";
				document.querySelector(".lesson-intro-more").style.display="none";
			},
			addFav(){
			  //先检查是否登录
        if(!this.$store.state.isLogin){
          this.isLoginDialogShow=true;
          return;
        }
				if(!this.isFav){
					this.$api.get("",{
						api:"/v1/course/collect",
						user_type:this.tools.getStorage("user_type"),
						id:this.$route.params.id
					},res=>{
						this.isFav=true;
					})
				}
				else{
					this.$api.get("",{
						api:"/v1/course/cancel_collect",
						user_type:this.tools.getStorage("user_type"),
						id:this.$route.params.id
					},res=>{
						this.isFav=false;
					})
				}
			},
			countStar(score){
				return Math.floor(score/2);
			},
			enroll(){
        //先检查是否登录
        // if(!this.$store.state.isLogin){//1
        //   this.isLoginDialogShow=true;
        //   return;
        // }
				this.$api.get("",{
					api:"/v1/baoming/create",
					user_type:this.tools.getStorage("user_type"),
					course_id:this.$route.params.id
				},res=>{
				  if(res.code==10011){
            this.$store.commit("setbind_link_url",this.$route.path);
				    this.$router.push('/bindphone');
				    console.log(this.$store.state.bind_link_url);
				    return;
				  }
					if(res.code==10111){
						this.$toast("报名成功！");
						if(this.lessons.length>0){
            //   this.enrollStatus=1;
			//判断是否登录，登录后改变按钮状态
				if(!this.$store.state.isLogin){
 					 this.enrollStatus=11;
				}else{
  					this.enrollStatus=1;
				}
              this.sectionId=res.data;
            }
            else{
              this.enrollStatus=5;
            }
					}
				})
			},
			countTime(time){
				var hour,
					minute,
					second;
				hour=parseInt(time/3600);
				if(hour<10) hour="0"+hour;
				minute=parseInt(time/60%60);
				if(minute<10) minute="0"+minute;
				second=parseInt(time%60);
				if(second<10) second="0"+second;
				return hour+":"+minute+":"+second;
			},
			toTeacher(id){
				this.$router.push("/teacher-lesson/"+id);
			},
      go_questionnaire(){
        let questionnaire_id = this.data.questionary_link.split('=')[1];
        window.location.href='/wx/survey_n/survey?id='+questionnaire_id+'&course_id='+this.$route.params.id + "&v_key=" + this.v_key;
      },
			checkEnroll(data){
		    var that = this;
				//检测报名状态
				//data.openStatus 0 暂未开放 1限时开放 三种状态  暂未开放   开放   已过期  2 开放
				//status只有为1才继续获取报名状态 0未开放 1开放 2过期
				var status;
				var openStatus=data.open_status;
				if(openStatus==0){//暂未开放
					this.enrollStatus=3;
				}else if(openStatus==1){//限时开放
					//需要判断是暂未开放还是已过期
					var nowTimestamp=new Date().getTime()/1000;
					var startTimestamp=data.start_time;
					var endTimestamp=data.end_time;
          // //对部分人开放
          // if(data.groupUserIds.length>0 || data.groupIds.length>0){
          //   var mytime = setInterval(function(){
          //     if(that.$store.state.myid!=null || that.$store.state.mygroupIds!=null){
          //       clearInterval(mytime);
          //       if(that.$store.state.myid){//已登录获取用户id
          //         //人员限制
          //         for(var i=0;i<data.groupUserIds.length;i++){
          //           if(Number(data.groupUserIds[i])==Number(that.$store.state.myid)){
          //             if(nowTimestamp < startTimestamp){
          //               status=0;
          //               that.enrollStatus=3;
          //             }else if(nowTimestamp > startTimestamp && nowTimestamp < endTimestamp){
          //               status=1;
          //               // that.enrollStatus=1;
          //               //login_status=1时需要登录，判断是否登录，登录后改变按钮状态；login_status=0时免登录
          //               if(that.login_status==1){
          //                 if(!that.$store.state.isLogin){
          //                   that.enrollStatus=11;
          //                 }else{
          //                   // that.enrollStatus=1;
          //                   that.enrollStatus=11;
          //                 }
          //               }else{
          //                 that.enrollStatus=1;
          //               }
          //               that.getUserStatus();
          //             }else if(nowTimestamp > endTimestamp){
          //               status=2;
          //               that.enrollStatus=4;
          //             }
          //             return false;
          //           }
          //         }
          //         //组限制
          //         if(that.$store.state.mygroupIds.length>0){
          //           for(var i=0;i<data.groupIds.length;i++){
          //             for(var j=0;j<that.$store.state.mygroupIds.length;j++){
          //               if(Number(data.groupIds[i])==Number(that.$store.state.mygroupIds[j])){
          //                 if(nowTimestamp < startTimestamp){
          //                   status=0;
          //                   that.enrollStatus=3;
          //                 }else if(nowTimestamp > startTimestamp && nowTimestamp < endTimestamp){
          //                   status=1;
          //                   // that.enrollStatus=1;
          //                   //login_status=1时需要登录，判断是否登录，登录后改变按钮状态；login_status=0时免登录
          //                   if(that.login_status==1){
          //                     if(!that.$store.state.isLogin){
          //                       that.enrollStatus=11;
          //                     }else{
          //                       // that.enrollStatus=1;
          //                       that.enrollStatus=11;
          //                     }
          //                   }else{
          //                     that.enrollStatus=1;
          //                   }
          //                   that.getUserStatus();
          //                 }else if(nowTimestamp > endTimestamp){
          //                   status=2;
          //                   that.enrollStatus=4;
          //                 }
          //                 return false;
          //               }
          //             }
          //           }
          //         }
          //         //当前用户不在部分人开放里面
          //         status=0;
          //         that.enrollStatus=3;
          //       }else{//未登录myid=0
          //         status=0;
          //         that.enrollStatus=3;
          //       }
          //     }
          //   },300)
          //   return false;
          // }
          //限时开放时全部人员开放
					if(nowTimestamp < startTimestamp){
						status=0;
						this.enrollStatus=3;
					}else if(nowTimestamp > startTimestamp && nowTimestamp < endTimestamp){
						// status=1;
			      //login_status=1时需要登录，判断是否登录，登录后改变按钮状态；login_status=0时免登录
            // if(this.login_status==1){
            //   if(!this.$store.state.isLogin){
            //     this.enrollStatus=11;
            //   }else{
            //     // this.enrollStatus=1;
            //     this.enrollStatus=11;
            //   }
            // }else{
            //   this.enrollStatus=1;
            // }
            // this.getUserStatus();
            //对部分人开放
            if(data.people_limit_status==1){
              if(data.groupUserIds.length>0 || data.groupIds.length>0){
                var mytime = setInterval(function(){
                  if(that.$store.state.myid!=null || that.$store.state.mygroupIds!=null){
                    clearInterval(mytime);
                    if(that.$store.state.myid){//已登录获取用户id
                      //人员限制
                      for(var i=0;i<data.groupUserIds.length;i++){
                        if(Number(data.groupUserIds[i])==Number(that.$store.state.myid)){
                          status=1;
                          //login_status=1时需要登录，判断是否登录，登录后改变按钮状态；login_status=0时免登录
                          if(that.login_status==1){
                            if(!that.$store.state.isLogin){
                              that.enrollStatus=11;
                            }else{
                              // that.enrollStatus=1;
                              that.enrollStatus=11;
                            }
                          }else{
                            that.enrollStatus=1;
                          }
                          that.getUserStatus();
                          return false;
                        }
                      }
                      //组限制
                      if(that.$store.state.mygroupIds.length>0){
                        for(var i=0;i<data.groupIds.length;i++){
                          for(var j=0;j<that.$store.state.mygroupIds.length;j++){
                            if(Number(data.groupIds[i])==Number(that.$store.state.mygroupIds[j])){
                              status=1;
                              // that.enrollStatus=1;
                              //login_status=1时需要登录，判断是否登录，登录后改变按钮状态；login_status=0时免登录
                              if(that.login_status==1){
                                if(!that.$store.state.isLogin){
                                  that.enrollStatus=11;
                                }else{
                                  // that.enrollStatus=1;
                                  that.enrollStatus=11;
                                }
                              }else{
                                that.enrollStatus=1;
                              }
                              that.getUserStatus();
                              return false;
                            }
                          }
                        }
                      }
                      //当前用户不在部分人开放里面
                      status=0;
                      that.enrollStatus=3;
                    }else{//未登录myid=0
                      status=0;
                      that.enrollStatus=3;
                    }
                  }
                },300)
              }
            }else{
              status=1;
              //login_status=1时需要登录，判断是否登录，登录后改变按钮状态；login_status=0时免登录
              if(this.login_status==1){
                if(!this.$store.state.isLogin){
                  this.enrollStatus=11;
                }else{
                  // this.enrollStatus=1;
                  this.enrollStatus=11;
                }
              }else{
                this.enrollStatus=1;
              }
              this.getUserStatus();
            }
					}else if(nowTimestamp > endTimestamp){
						status=2;
						this.enrollStatus=4;
					}
				}else if(openStatus==2){//开放
					status=1;
          //login_status=1时需要登录，判断是否登录，登录后改变按钮状态；login_status=0时免登录
          //对部分人开放
          if(data.people_limit_status==1){
            if(data.groupUserIds.length>0 || data.groupIds.length>0){
              var mytime = setInterval(function(){
                if(that.$store.state.myid!=null || that.$store.state.mygroupIds!=null){
                  clearInterval(mytime);
                  if(that.$store.state.myid){//已登录获取用户id
                    //人员限制
                    for(var i=0;i<data.groupUserIds.length;i++){
                      if(Number(data.groupUserIds[i])==Number(that.$store.state.myid)){
                        if(that.login_status==1){
                          if(!that.$store.state.isLogin){
                            that.enrollStatus=11;
                          }else{
                            // that.enrollStatus=1;
                            that.enrollStatus=11;
                          }
                        }else{
                          that.enrollStatus=1;
                        }
                        that.getUserStatus();
                        return false;
                      }
                    }
                    //组限制
                    if(that.$store.state.mygroupIds.length>0){
                      for(var i=0;i<data.groupIds.length;i++){
                        for(var j=0;j<that.$store.state.mygroupIds.length;j++){
                          if(Number(data.groupIds[i])==Number(that.$store.state.mygroupIds[j])){
                            if(that.login_status==1){
                              if(!that.$store.state.isLogin){
                                that.enrollStatus=11;
                              }else{
                                // that.enrollStatus=1;
                                that.enrollStatus=11;
                              }
                            }else{
                              that.enrollStatus=1;
                            }
                            that.getUserStatus();
                            return false;
                          }
                        }
                      }
                    }
                    //当前用户不在部分人开放里面
                    status=0;
                    that.enrollStatus=3;
                  }else{//未登录myid=0
                    status=0;
                    that.enrollStatus=3;
                  }
                }
              },300)
            }
            return false;
          }
          //无限时开放时全部人员开放
          if(this.login_status==1){
            if(!this.$store.state.isLogin){
              this.enrollStatus=11;
            }else{
              // this.enrollStatus=1;
              this.enrollStatus=11;
            }
          }else{
            this.enrollStatus=1;
          }
          this.getUserStatus();
		      // //判断是否登录，登录后改变按钮状态
          // if(!this.$store.state.isLogin){
          //   this.enrollStatus=1;
          // }else{
          //   this.enrollStatus=11;
          // }
				}
				if(status!=1){//status只有为1才继续获取报名状态
					return;
				}
				// this.$api.get("",{
				// 	api:"/v1/baoming/is_collect_bm_course",
				// 	course_id:this.$route.params.id,
				// 	user_type:this.tools.getStorage("user_type")
				// },res => {
				// 	var data=res.data;
				// 	if(data.is_baoming){
				// 		//如果课程是开放状态（状态不为3，4，也就是初始值-1），检测是开始学习还是继续学习
				// 		if(this.enrollStatus==-1){
				// 			this.$api.get("",{
				// 				api:"/v1/schedule/speed",
				// 				course_id:this.$route.params.id,
				// 				user_type:this.tools.getStorage("user_type")
				// 			},res => {
				// 				var data=res.data;
				// 				//是否有课程
				// 				if(data.all_section.length===0){
				// 					this.enrollStatus=5;
				// 				}
				// 				else{
				// 					//检测返回的课程是否存在，如果不存在，设置为列表中第一个课程
				// 					this.sectionId=data.all_section[0].id;
				// 					data.all_section.forEach((value,index)=>{
				// 						if(data.section_id===value){
				// 							this.sectionId=data.section_id;
				// 						}
				// 					})
				// 					if(data.total_time==0){
				// 						this.enrollStatus=1;
				// 					}
				// 					else{
				// 						this.enrollStatus=2;
				// 					}
				// 				}
				// 			})
				// 		}
				// 	}
				// 	else{
				// 		this.enrollStatus=0;
				// 	}
				// });
			},
      getUserStatus: function () {
        var that = this;
        this.$api.get("",{
          api:"/v1/schedule/speed",
          course_id:this.$route.params.id,
          user_type:this.tools.getStorage("user_type")
        },res => {
          var data=res.data;
          if(data.status == 0){
            // that.bm = '开始学习';
            return
          }
          if(data.total_time==0){
            // this.enrollStatus=1;
          } else{
            this.enrollStatus=2;
          }
        })
      },
			toLesson(id){
		    if(this.enrollStatus==3||this.enrollStatus==4){
		      //暂未开放、已过期禁止跳转
          return;
        }
				if(this.login_status==1){
        			if (!this.$store.state.isLogin) {
          				this.isLoginDialogShow = true;
          				return;
        			}
      			}
        		this.$router.push('/lesson-desc/'+this.$route.params.id+'/'+id);
				// if(this.enrollStatus==0){
				// 	this.$toast("请先报名");
				// }
				// else if(this.enrollStatus==3 || this.enrollStatus==4){
				// 	this.$toast("无法学习");
				// }
				// else{
				// 	this.$router.push('/lesson-desc/'+this.$route.params.id+'/'+id);
				// }
			}
		},
		created(){


      if (!/Android|webOS|iPhone|iPod|BlackBerry|HarmonyOS/i.test(navigator.userAgent)) {
        window.location.href = "/mooc_free_login/read?course_id="+ this.$route.params.id +"&v_key="+ this.v_key;
      }
			//课程详情
			this.$api.get("",{
				api:"/v1/course/read",
				course_id:this.$route.params.id
			},res => {
				var data=res.data;
				this.data=data;
				this.$nextTick(this.checkMore);
				//如果没有登录，就不用获取报名状态了，直接设置为0
        this.checkEnroll(data);
        // if(!this.$store.state.isLogin){
        //   this.enrollStatus=0;
        //   console.log(0)
        // }
        // else{
        //   this.checkEnroll(data);
        // }
			})
			//获取老师
			this.$api.get("",{
				api:"/v1/course/teacher_index",
				course_id:this.$route.params.id
			},res => {
				this.teachers=res.data;
			})
			//获取课程
			this.$api.get("",{
				api:"/v1/course/getCata",
				course_id:this.$route.params.id
			},res => {
				this.lessons=res.data;
				if(res.data.length != 0){
				  if(res.data[0].children.length != 0){
            this.sectionId = res.data[0].children[0].id;
				  }
				}
			})
			//如果登录了，获取是否已收藏
      if(this.$store.state.isLogin){
        this.$api.get("",{
          api:"/v1/baoming/is_collect_bm_course",
          course_id:this.$route.params.id,
          user_type:this.tools.getStorage("user_type")
        },res => {
          var data=res.data;
          if(data.is_collect){
            this.isFav=true;
          }
        })
      }
		},
		components:{
			star,
			"dialog-mask":mask
		}
	}
</script>

<style>
.info-surveybtn{
  position: absolute;
  bottom: 0;
  right: 0.4rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 2rem;
  height: .55rem;
  border: 1px solid #ec6d3a;
  text-align: center;
  line-height: .55rem;
  color: #ec6d3a;
  border-radius: .133rem;
}
	.lesson-detail-wrapper{
		position: relative;
		padding-bottom: 1.306rem;
	}
	.info{
		padding-bottom: 0.666rem;
		border-bottom:1px solid #e0e0e0;
	}
	.info-pic{
		height:5.173rem;
		width:10rem;
	}
	.info-title{
		margin:0.466rem 0.4rem 0 0.4rem;
		font-size: 0.613rem;
		line-height:0.987rem;
    color: #202020;
	}
	.info-line{
		margin-top:0.4rem;
	}
	.info-num{
		float:left;
		margin-left:0.4rem;
		font-size: 0.346rem;
		color:#000;
	}
	.info-num span{
		color:#EC6D3A;
	}
	.info-score{
		float:right;
		margin-right:0.4rem;
		font-size: 0.32rem;
		color:#EC6D3A;
	}
	.info-stars{
		display: inline-block;
	}
	.info-star{
		display: inline-block;
	}
	.info-star img{
		width:0.36rem;
	}
	.lesson-detail-title{
		margin-top:0.52rem;
		text-align: center;
		font-size: 0.346rem;
		line-height:0.346rem;
		color:#999;
	}
	.lesson-detail-title span{
		margin:0 0.12rem;
	}
	.lesson-detail-title img{
		width:0.4rem;
		vertical-align: middle;
	}
	.lesson-intro{
		padding-bottom: 0.666rem;
		border-bottom:1px solid #e0e0e0;
	}
	.lesson-intro-text{
		overflow: hidden;
		margin-top:0.266rem;
		padding:0 0.4rem;
		max-height:3.466rem;
		font-size: 0.373rem;
		line-height:0.56rem;
		color:#333;
	}
	.lesson-intro-text img{
		max-width: 100%;
	}
	.lesson-intro-more{
		position: relative;
		margin-top:-1rem;
		height:1rem;
		background:-webkit-linear-gradient(rgba(242,242,242,0),rgba(242,242,242,1));
	}
	.lesson-intro-more div{
		position: absolute;
		bottom:0;
		width:100%;
		height:0.16rem;
		text-align: center;
		background: url(./more.png) center center no-repeat;
		background-size: 0.293rem;
	}
	.teacher-intro{
		padding:0 0.4rem 0.533rem 0.4rem;
		border-bottom:1px solid #e0e0e0;
	}
	.teacher-intro-item{
		margin-top:0.32rem;
	}
	.teacher-intro-title{
		height:0.906rem;
		line-height:0.906rem;
		background: url(./enter.png) 9.066rem center no-repeat;
		background-size: 0.133rem;
	}
	.teacher-intro-avatar{
		overflow: hidden;
		float:left;
		height:0.906rem;
		width:0.906rem;
		border-radius: 50%;
	}
	.teacher-intro-name{
		float:left;
		margin-left:0.24rem;
		color:#3192E0;
		font-size: 0.426rem;
	}
	.teacher-intro-text{
		margin-left: 1.16rem;
		font-size: 0.346rem;
		line-height: 0.613rem;
		color:#333;
	}
	.catalog-chapters{
		margin-top:0.12rem;
		padding:0 0.4rem;
	}
	.catalog-chapter-title{
		height:1.173rem;
		line-height:1.173rem;
		font-size:0.4rem;
		color:#333;
		border-bottom:1px solid #e6e6e6;
	}
	.catalog-item{
		height:1.173rem;
		line-height:1.173rem;
		border-bottom:1px solid #e6e6e6;
	}
	.catalog-chapter:last-child .catalog-item:last-child{
		border-bottom: 0;
	}
	.catalog-item-title{
		float:left;
		margin-left:0.533rem;
		width:6.4rem;
		color:#666;
		font-size: 0.373rem;
	}
	.catalog-item-time{
		float:right;
		color:#999;
	}
	.catalog-item-time img{
		width:0.293rem;
		margin-right:0.133rem;
	}
	.bottom-bar{
		position: fixed;
		bottom:0;
		left:0;
		width:100%;
		height:1.306rem;
		background: #fff;
	}
	.bottom-bar-share,
	.bottom-bar-fav{
		float:left;
		box-sizing: border-box;
		width:25%;
		height:1.306rem;
		border-top:1px solid #eee;
		background: center center no-repeat;
		background-size: 0.506rem;
	}
	.bottom-bar-share{
		border-right: 1px solid #eee;
		background-image: url(./share.png);
	}
	.bottom-bar-fav{
		background-image: url(./fav.png);
	}
	.bottom-bar-fav-active{
		background-image: url(./fav-active.png);
	}
	.bottom-bar-enroll{
		float:left;
		width:50%;
		height:1.306rem;
		color:#fff;
		text-align: center;
		background: #EC6D3A;
		font-size: 0.4rem;
		line-height: 1.306rem;
	}
	.bottom-bar-enroll-disabled{
		background: #999;
	}
	.bottom-bar-enroll-enroll{
		background:#3192E0;
	}
	.share-dialog{
		display: none;
		position: absolute;
		top:0;
		left:0;
		width:100%;
		height:100%;
		background:rgba(0,0,0,0.6);
	}
	div.share-dialog-inner{
		position: fixed;
		width:100%;
    height:100%;
		font-size: 0.64rem;
		line-height:1.066rem;
		color:#fff;
		text-align: center;
    background: url(./point.png) top right no-repeat;
    background-size:2.373rem;
	}
  .share-dialog-text{
    padding-top:3.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/lesson-detail/lesson-detail.vue